import { Component, ElementRef, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  ContratoService, ConvenioService, DespesaService, EmpenhoAnexoService,
  FichaDespesaService, LicitacaoService
} from 'administrativo-lib';
import { ProdutoService, ProdutoUnidadeService } from 'almoxarifado-lib';
import {
  AssinaturaService, BaseResourceFormComponent, Compra, CompraItem, DateFormatPipe, Exercicio, FavorecidoService, FichaDespesa, FuncaoService, GlobalService, LoginContabil, PessoaService
} from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import { ModalidadeService } from '../../modalidade/service/modalidade.service';
import { CompraItemService } from '../service/compra-item.service';
import { CompraService } from '../service/compra.service';


type Card = {
  dotacao: number,
  reservado: number,
  saldo: number,
  empenhado: number,
  liquidado: number,
  pago: number
}

declare var $: any;

@Component({
  selector: 'app-compra-view',
  templateUrl: './compra-view.component.html'
})
export class CompraViewComponent extends BaseResourceFormComponent<Compra, LoginContabil> {

  /**
   * Auto completes
   */

  /**
  * Declaração de variáveis
  */
  public listaItens: CompraItem[] = [];
  public dadosCard: Card;

  public visualizarRCMS: boolean = false;
  public visualizarFicha: boolean = false;

  public tab: number = 1;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected globalService: GlobalService,
    public funcaoService: FuncaoService,
    protected favorecidoService: FavorecidoService,
    protected anexoService: EmpenhoAnexoService,
    protected despesaService: DespesaService,
    protected fichaService: FichaDespesaService,
    protected licitacaoService: LicitacaoService,
    protected contratoService: ContratoService,
    protected convenioService: ConvenioService,
    protected modalidadeService: ModalidadeService,
    protected itemService: CompraItemService,
    protected assinaturaService: AssinaturaService,
    protected produtoService: ProdutoService,
    protected pessoaService: PessoaService,
    protected produtoUnService: ProdutoUnidadeService,
    protected compraService: CompraService) {
    super(new Compra(), injector, Compra.converteJson, compraService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      numero: [null, [Validators.required]],
      tipo_compra: ['O', [Validators.required]],
      data_compra: [new Date(), [Validators.required]],
      prazo_entrega: [null, [Validators.required]],
      prazo_pagamento: [null, [Validators.required]],
      adiantamento: [false, [Validators.required]],
      documento: [null],
      modalidade: [null, Validators.required],
      observacao: [null],
      ficha: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      exercicio: [this.login.exercicio, [Validators.required]],
      favorecido: [null, [Validators.required]],
      subelemento: [null, [Validators.required]],
      rcms: this.fb.group({
        id: [null],
        numero: [null]
      }),
      ata: [null],
      licitacao: this.fb.group({
        id: [null],
        numero: [null]
      }),
      processo: [null],
      contrato: this.fb.group({
        id: [null],
        numero: [null],
      }),
      convenio: [null],
      itens: [null],
      requerente: [null, [Validators.required]],
    });
  }

  protected parametrosExtras(): {} {
    return {
      relations: ['ficha', 'modalidade', 'licitacao', 'subelemento',
        'convenio', 'favorecido', 'contrato', 'ficha.despesa', 'exercicio', 'orgao', 'itens',
        'itens.produto_unidade', 'itens.produto_unidade.produto', 'itens.produto_unidade.unidade',
        'contrato', 'requerente', 'rcms', 'prazo', 'empenho'
      ]
    };
  }

  protected afterInit(): void {
    this.carregarCard();
  }

  protected campoFoco(): ElementRef {
    return null;
  }

  protected async afterLoad() {
    console.log(this.entidade)
    this.entidade.data_compra = new DateFormatPipe().transform(this.entidade.data_compra, []);
    this.entidade.data_pagamento = new DateFormatPipe().transform(this.entidade.data_pagamento, []);
    this.entidade.data_entrega = new DateFormatPipe().transform(this.entidade.data_entrega, []);

    this.buscarTotalizadores();

    this.listaItens = this.entidade.itens;
  }

  protected beforeSubmit() { }

  protected afterSubmit(ent: Compra) { }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  private buscarTotalizadores() {
    this.carregarCard();

    const exercicio: Exercicio = this.entidade.exercicio ? this.entidade.exercicio : this.entidadeForm.get('exercicio').value;
    const ficha: FichaDespesa = this.entidade.ficha ? this.entidade.ficha : this.entidadeForm.get('ficha').value;
    const dataCompra: Date = this.entidade.data_compra ? this.entidade.data_compra : this.entidadeForm.get('data_compra').value;

    if (!ficha || !dataCompra || !exercicio)
      return;
    this.compraService.totalizadoresFicha(
      exercicio.id, this.login.orgao.id, ficha.id,
      String(this.funcaoService.converteDataSQL(new DateFormatPipe().transform(dataCompra, ['local']))))
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data)
          this.carregarTotalizadores(data);
      })
  }

  private carregarTotalizadores(totalizadores: {
    comprado: number, empenhado: number, liquidado: number, pago: number, reservado: number,
    comprado_ficha: number, dotacao_ficha: FichaDespesa, creditado_ficha: number
  }) {
    this.carregarCard();

    if (!totalizadores)
      return;

    this.dadosCard.empenhado = totalizadores.empenhado;
    this.dadosCard.liquidado = totalizadores.liquidado;
    this.dadosCard.pago = totalizadores.pago;

    this.dadosCard.dotacao = +totalizadores.dotacao_ficha + +totalizadores.creditado_ficha;
    this.dadosCard.reservado = totalizadores.reservado;

  }

  private carregarCard() {
    this.dadosCard = {
      empenhado: 0,
      dotacao: 0,
      liquidado: 0,
      pago: 0,
      reservado: 0,
      saldo: 0
    }
  }

  public valorTotal() {
    let valorTotal = 0.0;
    if (!this.listaItens || this.listaItens.length === 0)
      return valorTotal;
    for (let item of this.listaItens) {
      valorTotal += item.quantidade * item.valor_unitario;
    }
    return valorTotal;
  }

  public selecionarTab(tab: number) {
    this.tab = tab;
  }

  public tabSelecionado(tab: number) {
    return this.tab === tab;
  }

  public tipoCompra(tipo: string) {
    let tiposCompra = this.globalService.obterListaTiposEmpenhos();
    let tipocompra = tiposCompra.find((t) => t.id === tipo);
    if (tipocompra)
      return tipocompra.nome;
    return '';
  }

  voltar(){
    window.history.back();
  }

}
